import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "NewsletterSettings",
    component: () =>
        __SERVER__ ? require("./newsletter-settings-view") : import("./newsletter-settings-view")
});

export default definition;
